import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTalleres } from 'services/servicioGet';
import { TallerListado } from 'utils/models/types';

interface TalleresState {
  talleres: TallerListado[];
  loadingTalleres: boolean;
  errorTalleres: string | null;
}

// Estado inicial del slice
const initialState: TalleresState = {
  talleres: [],
  loadingTalleres: false,
  errorTalleres: null,
};

// Thunk para obtener los talleres
export const fetchTalleres = createAsyncThunk('talleres/fetchTalleres', async (_, { rejectWithValue }) => {
  try {
    const response = await getTalleres();
    return response;
  } catch (error: unknown) {
    return rejectWithValue(error instanceof Error ? error.message : String(error));
  }
});

// Slice de talleres
const talleresSlice = createSlice({
  name: 'talleres',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTalleres.pending, state => {
        state.loadingTalleres = true;
        state.errorTalleres = null;
      })
      .addCase(fetchTalleres.fulfilled, (state, action) => {
        state.talleres = action.payload;
        state.loadingTalleres = false;
      })
      .addCase(fetchTalleres.rejected, (state, action) => {
        state.loadingTalleres = false;
        state.errorTalleres = action.payload as string;
      });
  },
});

export default talleresSlice.reducer;
